import { render, staticRenderFns } from "./bottom-menu.vue?vue&type=template&id=0357e56a&scoped=true"
import script from "./bottom-menu.vue?vue&type=script&lang=js"
export * from "./bottom-menu.vue?vue&type=script&lang=js"
import style0 from "./bottom-menu.vue?vue&type=style&index=0&id=0357e56a&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0357e56a",
  null
  
)

export default component.exports